var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuOpened = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 11H1.33333C0.596954 11 0 11.6716 0 12.5C0 13.3284 0.596954 14 1.33333 14H5.33333H10.6667H13.3333H16H22.6667C23.403 14 24 13.3284 24 12.5C24 11.6716 23.403 11 22.6667 11H18.6667H13.3333H10.6667H5.33333Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuOpened);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-opened.4c7d4cefe246e773e63459a4ff94b622.svg";